import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";
import {toast} from 'react-toastify';
import CreateEditUserLeaveRequestModal from "../modals/CreateEditUserLeaveRequestModal";
import ArchiveUserLeaveRequestModal from "../modals/ArchiveUserLeaveRequestModal";

const UserLeaveRequestDataTable = (props) => {
    const {
        userId = null
    } = props;

    const dataTableRef          = useRef(null);
    const [search, setSearch]   = useState("");

    const [createEditUserLeaveRequestModal, setCreateEditUserLeaveRequestModal] = useState(false);
    const [archiveUserLeaveRequestModal, setArchiveUserLeaveRequestModal]       = useState(null);

    const renderRowButton = (userLeaveRequest) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!userLeaveRequest.can && (userLeaveRequest.can.update === true || userLeaveRequest.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!userLeaveRequest.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setCreateEditUserLeaveRequestModal(userLeaveRequest.id)}
                                    >
                                        <span>Edit</span>
                                    </button>
                                )}
                                {!!userLeaveRequest.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveUserLeaveRequestModal(userLeaveRequest)}
                                    >
                                        <span>Delete</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card title={"Leave Requests"} classes={"mb-0 mh-100 border-0"}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-lg-between"}>
                    <div className="col-12 col-lg-6 m-0 mb-4 mb-lg-0 p-0 pl-lg-2 order-lg-2">
                        <div className={"d-flex justify-content-end align-items-center"}>
                            {can('create', 'userLeaveRequest') && (
                                <Button
                                    onClick={() => setCreateEditUserLeaveRequestModal(true)}
                                    label={"Add Leave"}
                                    icon={"fal fa-plus-circle"}
                                    classes={"btn btn-eh-lilac px-4 m-0"}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 m-0 p-0 pr-lg-2 order-lg-1">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.user-leave-request.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="leave requests" />}
                                fieldsToExclude={[
                                    'id',
                                    'user_id',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    start_at:   "Requested Start Date",
                                    end_at:     "Requested End Date",
                                    difference: "Number Of Days"
                                }}
                                fieldOrder={[
                                    'reason',
                                    'start_at',
                                    'end_at',
                                    'difference',
                                ]}
                                ref={dataTableRef}
                                defaultOrderByField={'start_at'}
                                defaultOrderByDirection={'desc'}
                                params={{
                                    searchTerm: search,
                                    userId:     userId
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        default:
                                            return <span>{value}</span>;
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <CreateEditUserLeaveRequestModal
                show={!!createEditUserLeaveRequestModal}
                userLeaveRequestId={(createEditUserLeaveRequestModal !== true && createEditUserLeaveRequestModal !== false && createEditUserLeaveRequestModal !== null) ? createEditUserLeaveRequestModal : null}
                userId={userId}
                parentId={'user-leave-request-datatable'}
                onCancel={() => setCreateEditUserLeaveRequestModal(false)}
                onConfirm={() => {
                    setCreateEditUserLeaveRequestModal(false);
                    dataTableRef.current.reload();
                    toast.success(<div>{(createEditUserLeaveRequestModal !== true && createEditUserLeaveRequestModal !== false && createEditUserLeaveRequestModal !== null) ? "Leave request updated." : "Leave request created."}</div>);
                }}
            />
            <ArchiveUserLeaveRequestModal
                show={!!archiveUserLeaveRequestModal}
                userLeaveRequest={!!archiveUserLeaveRequestModal ? archiveUserLeaveRequestModal : null}
                parentId={'user-leave-request-datatable'}
                onCancel={() => setArchiveUserLeaveRequestModal(null)}
                onConfirm={() => {
                    setArchiveUserLeaveRequestModal(null);
                    dataTableRef.current.reload();
                    toast.success(<div>{"Leave request deleted."}</div>);
                }}
            />
        </React.Fragment>
    );
}

export default UserLeaveRequestDataTable;

const target = document.getElementById('user-leave-request-datatable');
if (target) {
    const {
        userId = null,
    } = target.dataset;

    ReactDOM.render(<UserLeaveRequestDataTable userId={userId} />, target);
}
